// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__i1Un2","content":"layout_content__I+ls2","main":"layout_main__I0Iy9"};